import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Component, OnInit } from '@angular/core';
import { EduBannerService } from 'src/app/service/context/edu/edu-banner.service';

@Component({
    selector: 'app-edu-banner',
    templateUrl: './edu-banner.component.html',
    styles: []
})
export class EduBannerComponent implements OnInit {
    constructor(
        private eduBannerservice: EduBannerService,
        private toastr: ToastrService,
        private router: Router
    ) { }

    eduBanners: any[] = [];

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.eduBannerservice.getListEduBanner().subscribe(
            res => {
                this.eduBanners = <any>res;
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    onRefresh() {
        this.loadData();
    }

    onEdit(guid) {
        this.router.navigateByUrl('/techbyte/admin/edu-banner/edit/' + guid);
    }

    onRemove(guid) {
        document.getElementById('page-loader-data').style.display = "block";
        this.eduBannerservice.deleteEduBanner(guid).subscribe(
            res => {
                this.toastr.success("Thành công");
                this.loadData();
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }
}